import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/login", { email, password });
      toast.success("Welcome back");
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0D0F12] flex items-center justify-center px-6 font-body" data-testid="admin-login-page">
      <div className="w-full max-w-md bg-[#161B22] border border-white/10 rounded-3xl p-10">
        <div className="flex justify-center">
          <div className="bg-white rounded-xl px-4 py-2">
            <img src="/logo.png" alt="A-Z Concepts UK Ltd" className="h-10 w-auto" />
          </div>
        </div>
        <h1 className="mt-6 font-heading text-2xl font-extrabold text-white text-center" data-testid="admin-login-heading">Owner Login</h1>
        <p className="mt-2 text-sm text-slate-400 text-center">Manage enquiries and edit your website content.</p>
        <form onSubmit={submit} className="mt-8 space-y-5" data-testid="admin-login-form">
          <div>
            <Label htmlFor="admin-email" className="text-slate-300">Email</Label>
            <Input id="admin-email" type="email" required data-testid="admin-login-email-input"
              value={email} onChange={(e) => setEmail(e.target.value)} placeholder="admin@azconcepts.org"
              className="mt-2 bg-[#0D0F12] border-white/10 text-white placeholder:text-slate-500" />
          </div>
          <div>
            <Label htmlFor="admin-password" className="text-slate-300">Password</Label>
            <Input id="admin-password" type="password" required data-testid="admin-login-password-input"
              value={password} onChange={(e) => setPassword(e.target.value)} placeholder="••••••••"
              className="mt-2 bg-[#0D0F12] border-white/10 text-white placeholder:text-slate-500" />
          </div>
          {error && <p className="text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
          <button type="submit" disabled={loading} data-testid="admin-login-submit-button"
            className="w-full bg-[#FF5A1F] hover:bg-[#E04810] disabled:opacity-60 text-white font-bold rounded-full py-3.5 transition-colors">
            {loading ? "Signing in..." : "Sign In"}
          </button>
        </form>
        <p className="mt-6 text-center">
          <Link to="/" data-testid="admin-login-back-link" className="text-sm text-slate-400 hover:text-[#FF5A1F] transition-colors">← Back to website</Link>
        </p>
      </div>
    </div>
  );
}
